import React, { useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLang } from '../LanguageContext';
import { getFarmOverviewPath } from '../utils/farmRoutes';

export default function InviteAcceptPage() {
  const navigate = useNavigate();
  const { t } = useLang();
  const [searchParams] = useSearchParams();
  const inviteToken = useMemo(() => searchParams.get('token') || '', [searchParams]);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!inviteToken) {
      setStatus(t('invitePage.missingToken'));
      return;
    }
    setBusy(true);
    setStatus('');
    try {
      const res = await fetch('/api/auth/register-invite', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, inviteToken }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setStatus(data.error || t('invitePage.registrationFailed'));
        return;
      }
      localStorage.setItem('token', data.token);
      localStorage.setItem('login', email);
      window.dispatchEvent(new Event('storage'));
      let target = '/';
      try {
        const payload = JSON.parse(atob(data.token.split('.')[1]));
        const path = getFarmOverviewPath(payload.farmId);
        if (path) target = path;
      } catch {
        /* ignore */
      }
      navigate(target, { replace: true });
    } catch (err) {
      setStatus(t('invitePage.registrationFailed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container mt-3" style={{ maxWidth: 460 }}>
      <h1 className="mb-3">{t('invitePage.title')}</h1>
      {!inviteToken ? (
        <div className="alert alert-warning">{t('invitePage.invalidLink')}</div>
      ) : (
        <form onSubmit={submit}>
          <input
            className="form-control mb-2"
            type="email"
            placeholder={t('invitePage.emailPlaceholder')}
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            className="form-control mb-2"
            type="password"
            placeholder={t('invitePage.passwordPlaceholder')}
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {status ? <div className="text-danger mb-2">{status}</div> : null}
          <button className="btn btn-primary" type="submit" disabled={busy}>
            {busy ? t('invitePage.creatingAccount') : t('invitePage.createAccount')}
          </button>
        </form>
      )}
    </div>
  );
}
